import axios from "../axiosPlugin.js";

export const getHouseList = (data, loading = true, isDefaultAlertTips = true) => {
  let defaultData = {
    page: 0,
    pageSize: 9999,
    ...data,
  };

  return axios({
    url: "/api/house/list",
    method: "get",
    data: {
      data: {
        ...defaultData,
      },
      loading,
      isDefaultAlertTips,
    },
  });
};

export const getHouseListOptions = (data, loading = true, isDefaultAlertTips = true) => {
  let defaultData = {
    page: 0,
    pageSize: 9999,
    ...data,
  };

  return axios({
    url: "/api/house/list-options",
    method: "get",
    data: {
      data: {
        ...defaultData,
      },
      loading,
      isDefaultAlertTips,
    },
  });
}
export const getRoleList = (data, loading = true, isDefaultAlertTips = true) => {
  return axios({
    url: "/api/role/list",
    method: "get",
    data: {
      data,
      loading,
      isDefaultAlertTips,
    },
  });
};

export const getSystemType = (data, loading = true, isDefaultAlertTips = true) => {
  return axios({
    url: "/api/system/types",
    method: "get",
    data: {
      data,
      loading,
      isDefaultAlertTips,
    },
  });
};

export const getGlobalMovieList = (data, loading = true, isDefaultAlertTips = true) => {
  return axios({
    // url: "/api/film/globalList",
    url: "/api/film/creatFilmNameList",
    method: "get",
    data: {
      data,
      loading,
      isDefaultAlertTips,
    },
  });
};

export const getMovieList = (data, loading = true, isDefaultAlertTips = true) => {
  return axios({
    url: "/api/film/list",
    method: "get",
    data: {
      data,
      loading,
      isDefaultAlertTips,
    },
  });
};

export const getSimpleMovieList = (data, loading = true, isDefaultAlertTips = true) => {
  const adminType = window.localStorage.getItem("adminType");
  const brandId = window.localStorage.getItem("brandId");
  const cinemaId = window.localStorage.getItem("cinemaId");
  const adminScopeData = {};

  if (adminType === "brand" && brandId) {
    adminScopeData.brandId = brandId;
    adminScopeData.accountType = "cinema";
  }

  if (adminType === "cinema" && cinemaId) {
    adminScopeData.cinemaId = cinemaId;
  }

  return axios({
    url: "/api/film/listMap",
    method: "get",
    data: {
      data: {
        ...data,
        ...adminScopeData,
      },
      loading,
      isDefaultAlertTips,
    },
  });
};

export const getMovieStaff = (data, loading = true, isDefaultAlertTips = true) => {
  return axios({
    url: "/api/filmmakers/listMap",
    method: "get",
    data: {
      data,
      loading,
      isDefaultAlertTips,
    },
  });
};

export const uploadFile = (data, loading = true) => {
  return axios({
    url: "/api/system/uploadFile",
    method: "uploadfile",
    data: {
      data,
      loading
    },
  });
};

export const rulesList = (data, loading = true, isDefaultAlertTips = true) => {
  return axios({
    url: "/api/ticketRuleTemplate/list",
    method: "get",
    data: {
      data,
      loading,
      isDefaultAlertTips,
    },
  });
};

export const getCinemaList = (data, loading = true, isDefaultAlertTips = true) => {
  return axios({
    url: "/api/cinema/list",
    method: "get",
    data: {
      data,
      loading,
      isDefaultAlertTips,
    },
  });
};

export const getCinemaListMap = (data, loading = true, isDefaultAlertTips = true) => {
  return axios({
    url: "/api/cinema/listMap",
    method: "get",
    data: {
      data,
      loading,
      isDefaultAlertTips,
    },
  });
};

export const getRegions = (data, loading = true, isDefaultAlertTips = true) => {
  return axios({
    url: "/api/system/regions",
    method: "get",
    data: {
      data,
      loading,
      isDefaultAlertTips,
    },
  });
};

export const getOtherVersion = (data, loading = true, isDefaultAlertTips = true) => {
  return axios({
    url: "/api/otherVersion/List",
    method: "get",
    data: {
      data,
      loading,
      isDefaultAlertTips,
    },
  });
};

export const getVersion = (data, loading = true, isDefaultAlertTips = true) => {
  return axios({
    url: "/api/version/list",
    method: "get",
    data: {
      data,
      loading,
      isDefaultAlertTips,
    },
  });
};

export const resetPassword = (data, loading = true, isDefaultAlertTips = true) => {
  let query = `userName=${data.userName}&oldPassword=${data.oldPassword}&newPassword=${data.newPassword}`;

  return axios({
    url: `/api/updateExpiredPassword?${query}`,
    method: "post",
    data: {
      data,
      loading,
      isDefaultAlertTips,
    },
  });
};

export const getGroupListService = data => {
  return axios({
    url: "/api/group/list",
    method: "get",
    data: { data },
  });
};

export const getGroupListForCounponService = data => {
  return axios({
    url: "/api/group/listForCoupon",
    method: "get",
    data: { data },
  });
};
export const getSalesGroupListService = data => {
  return axios({
    url: "/api/salesGroup/list",
    method: "get",
    data: { data },
  });
};

export const getClientListService = (data = {}, loading = false, isDefaultAlertTips = false) => {
  const { page, pageSize } = data;

  if (!page) { data.page = 0; }
  if (!pageSize) { data.pageSize = 9999; }

  return axios({
    url: "/api/client/listMap",
    method: "get",
    data: { data, loading, isDefaultAlertTips },
  });
};

export const loginService = (data, loading = true, isDefaultAlertTips = false) => {
  return axios({
    url: "api/login",
    method: "post",
    data: {
      data,
      loading,
      isDefaultAlertTips,
    },
  });
};

export const approve = (data, url, approveType, isReqBody) => {
  let query = "";
  // let cinemas = [];
  // let cinemaQuery = "";
  
  // if (!isReqBody) {
  //   JSON.parse(window.localStorage.getItem("cinemaObj")).forEach(item => {
  //     cinemas.push(item.id);
  //   });
  //   cinemas.forEach(item => {
  //     cinemaQuery += "&selectiveCinemaIds=" + item;
  //   });
  // }
  // if (path === "coupon" || path === "ticket") {
  //   query = `brandId=${data.brandId}&cinemaId=${data.cinemaId}&reflect=${data.reflect}${data.reflectDate ? "&reflectDate=" + data.reflectDate : "&reflectDateTime=" + data.reflectDateTime}${path === "coupon" || path === "ticket" ? "&selectiveCinemaIds=" + cinemaQuery : "" }`;
  // } else {
  //   query = `${data.brandId ? "brandId=" + data.brandId : "cinemaId=" + data.cinemaId}&reflect=${data.reflect}${data.reflectDate ? "&reflectDate=" + data.reflectDate : "&reflectDateTime=" + data.reflectDateTime}${path === "coupon" || path === "ticket" ? "&selectiveCinemaIds=" + cinemaQuery : "" }`;
  // }
  query = `${data.brandId ? "brandId=" + data.brandId : "cinemaId=" + data.cinemaId}&reflect=${data.reflect}&reflectDate=${data.reflectDate}`;
  return axios({
    url: isReqBody ? `${url}/${approveType}` : `${url}/${approveType}?${query}`,
    method: "post",
    data: isReqBody ? { data } : {},
  });
};

export const getSystemSetting = () => {
  return axios({
    url: "/api/system/setting",
    method: "get",
    data: {}
  });
};

export const getBrandDetail = brandId => {
  return axios({
    url: "/api/brand/detail/" + brandId,
    method: "get",
    data: {}
  });
}

export const logoutService = () => {
  return axios({
    url: "/api/logout",
    method: "post",
    data: {},
  });
};

export const getNotiListService = (data, loading = true, isDefaultAlertTips = true) => {
  return axios({
    url: "/api/deviceNotificationLog/list",
    method: "get",
    data: { data, loading, isDefaultAlertTips },
  });
};

export const getAccountDetailService = accountId => {
  return axios({
    url: `/api/account/detail/${accountId}`,
    method: "get",
    data: {},
  });
};

export const downFileBase64 = data => {
  return axios({
    url: "/api/system/downloadFileBase64",
    method: "GET",
    data: {
      data,
    }
  });
};

export const getAreaListService = data => {
  return axios({
    url: "/api/cl/address/area-list",
    method: "GET",
    data: {
      data,
    }
  });
};

export const getPrefectureListService = data => {
  return axios({
    url: "/api/cl/address/prefecture-list",
    method: "GET",
    data: {
      data,
    }
  });
};

export const getDistListService = data => {
  return axios({
    url: "/api/cl/address/district-list",
    method: "GET",
    data: {
      data,
    }
  });
};